

















import { Component, Prop, Vue } from 'vue-property-decorator';
import { CalendarHeader, CalendarMonth } from './components';
import { DAYS_OF_WEEK } from './consts';

@Component({
  components: {
    CalendarHeader,
    CalendarMonth,
  },
})
export default class CalendarBlock extends Vue {
  @Prop({ type: Array, default: () => [] })
  readonly items!: Array<any>;

  @Prop({ type: Number, default: 1 })
  readonly month!: number;

  @Prop({ type: Number, default: 2020 })
  readonly year!: number;

  readonly daysOfTheWeeks: Array<string> = DAYS_OF_WEEK;

  openPopup(day: string) {
    this.$emit('openPopup', day);
  }

  prev() {
    this.$emit('prevMonth');
  }

  next() {
    this.$emit('nextMonth');
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/profile/modules/remote-edu/calendar/components/calendar/CalendarBlock.vue